/**
 * @file src/js/datasources/kaltura/services/episodes.js
 * @description Header of the series page.
 * @author Gonzalo Lopez <gonzalo.lopez@24imedia.com>
 */
import {
    convertForSeriesPage,
    convertForGetSeriesEpisodes,
    convertFromGetSeriesEpisodes
} from 'datasources/kaltura/adapters/pages/series';

import {convertFromRead} from 'datasources/kaltura/adapters/assets';

/**
 * Returns the series page content: Series asset and its episodes.
 *
 * @param {number} seriesId - Id of the series.
 * @returns {Promise} Promise.
 */
export function getSeriesPage (seriesId) {
    const url = this._baseUrl + this._endPoints.asset,
        results = {};

    return this.read(
        {
            url: url,
            data: convertForSeriesPage.call(this, seriesId)
        })
        .then(response => {
            return (results.series = convertFromRead.call(this, response.result || null));
        })
        .then((series = {}) => {
            return this.read({
                url: this._baseUrl + this._endPoints.assetList,
                data: convertForGetSeriesEpisodes.call(this, series.title)
            });
        })
        .then((response = {}) => {

            results.episodes = convertFromGetSeriesEpisodes.call(this, response.result || []);

            return results;
        })
        .catch(response => {
            return response;
        });
}



// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/pages/series.js